import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { AdvisorsGuestNav } from '@src/components/sco/Advisors/layout/AdvisorsGuestNav';
import { AdvisorsNav } from '@src/components/sco/Advisors/layout/AdvisorsNav';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { MembersNav } from '@src/components/sco/Members/MembersLayout/MembersNav';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import { gql } from '@src/lib/gql';
import { memberSlugParam } from '@src/lib/memberProfileStatus';
import { useRouter } from 'next/router';

/**
 * Same `groupMemberUser` read as `UserProfile` (one cache entry, server-rendered with the tree),
 * so picking the rail adds no request on the client.
 */
const MEMBER_PROFILE_NAV_USER = gql`
  query MemberProfileNavUser($userSlug: String) {
    groupMemberUser(userSlug: $userSlug) {
      id
      userId
      advisorProfile {
        id
        advisorProfileId
        isApproved
      }
    }
  }
`;
type MemberProfileNavData = {
  groupMemberUser?: {
    userId?: string;
    advisorProfile?: {
      isApproved?: boolean | null;
    } | null;
  } | null;
};

/**
 * Left rail for a member profile (`/members/[slug]` and its aliases). An approved marketplace
 * advisor's canonical page (L5) gets the Advisors rail with Find Advisors lit — the same chrome as
 * `/advisors/profile/[slug]` — instead of the founder search filters (real-data walk #7). Everyone
 * else keeps the Members rail. The URL and canonical never change.
 */
export const MemberProfileNav = () => {
  const $ = _c(11);
  const router = useRouter();
  const paths = useAdvisorsPaths();
  const {
    currentUser
  } = useCurrentUser();
  let t0;
  if ($[0] !== router.query.memberSlug) {
    t0 = memberSlugParam(router.query.memberSlug);
    $[0] = router.query.memberSlug;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const userSlug = t0;
  let t1;
  if ($[2] !== userSlug) {
    t1 = {
      userSlug
    };
    $[2] = userSlug;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = !userSlug;
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = {
      variables: t1,
      skip: t2
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const query = useQuery(MEMBER_PROFILE_NAV_USER, t3);
  if (!query.data?.groupMemberUser?.advisorProfile?.isApproved) {
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <MembersNav />;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    return t4;
  }
  if (!currentUser || currentUser.isGuest) {
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <AdvisorsGuestNav />;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    return t4;
  }
  let t4;
  if ($[9] !== paths.directory) {
    t4 = <AdvisorsNav activePath={paths.directory} />;
    $[9] = paths.directory;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};